import React from 'react';
import { Row } from 'react-bootstrap';
import {
  buildWhereForDates,
  FormCol,
  FormFilterCard,
  FieldInput,
  FieldDateRanger,
  FieldSelectIsActive,
} from 'motion-components';
import { useTranslation } from 'react-i18next';
import { FieldSelectWasteReceptionPoint } from 'shared-pages';
import { useRootStore } from 'store';
import { isFotokiklosi } from 'shared-pages/common/constants';

/* ----------------------- Διαχείριση Φίλτρων ------------------------------ */
export function buildWhereFromFilterValues(values): string {
  // Φτιάξε το where για το graphql
  let where = {};
  if (values) {
    if (values.searchText) {
      const searchText = '%' + values.searchText + '%';
      const likeObj = { $like: searchText };
      where = {
        ...where,
        $or: [{ code: likeObj }, { notes: likeObj }],
      };
    }
    if (values.isActive !== undefined && values.isActive !== null && values.isActive !== '') {
      where = { ...where, isActive: values.isActive };
    }
    if (values.startDate || values.endDate) {
      where = {
        ...where,
        ...buildWhereForDates(values.startDate, values.endDate, 'transactionDate'),
      };
    }
    if (values.fromWastereceptionpointId) {
      where = { ...where, fromWastereceptionpointId: values.fromWastereceptionpointId };
    }
    if (values.toWastereceptionpointId) {
      where = { ...where, toWastereceptionpointId: values.toWastereceptionpointId };
    }
  }
  return JSON.stringify(where);
}

/* ----------------------- Filter Form ------------------------------ */
export const Filters = ({ onChange, initialValues, disable = false }) => {
  //
  const { appStore, authStore } = useRootStore();
  const { t } = useTranslation();
  // Restrict WasteReception Points to Collector's Only
  const _restrictWastereceptionpoints =
    (appStore.isCollector || appStore.isCollectorDriver) && isFotokiklosi ? true : false;
  const _collectorId =
    appStore.isCollector || appStore.isCollectorDriver ? appStore.associatedId : undefined;

  function handleFiltersSubmit(values, { setSubmitting }) {
    if (disable) return;
    setTimeout(() => {
      setSubmitting(false);
      onChange(values);
    }, 400);
  }

  const filters = {
    searchText: initialValues?.searchText ?? '',
    isActive: initialValues?.isActive ?? null,
    startDate: initialValues?.startDate ?? null,
    endDate: initialValues?.endDate ?? null,
    fromWastereceptionpointId: initialValues?.fromWastereceptionpointId ?? null,
    toWastereceptionpointId: initialValues?.toWastereceptionpointId ?? null,
  };

  return (
    <FormFilterCard
      title={t('Κριτήρια Αναζήτησης')}
      onSubmit={handleFiltersSubmit}
      initialValues={filters}
    >
      <Row>
        <FieldInput
          as={FormCol}
          name="searchText"
          label={t('Αναζήτηση ( Κωδικός, Σημειώσεις )')}
          type="search"
          disable={disable}
        />
        <FieldDateRanger as={FormCol} label="Αίτηση από" name="startDate" name2="endDate" />
        <FieldSelectIsActive label={t('Ενεργές Εγγραφές')} disable={disable} />
      </Row>
      <Row>
        <FieldSelectWasteReceptionPoint
          label="Προέλευση"
          name="fromWastereceptionpointId"
          as={FormCol}
          collectorId={_restrictWastereceptionpoints ? _collectorId : undefined}
        />

        <FieldSelectWasteReceptionPoint
          label="Προορισμός"
          name="toWastereceptionpointId"
          as={FormCol}
          collectorId={_restrictWastereceptionpoints ? _collectorId : undefined}
        />
      </Row>
    </FormFilterCard>
  );
};
